import type {
  TableColumnHeaderProps,
  TextProps} from '@chakra-ui/react'
import {
  Grid,
  Text,
  Th,
} from '@chakra-ui/react'

export interface DashboardThProps extends TableColumnHeaderProps {
  labels?: string[] | React.ReactNode[]
  labelProps?: TextProps
}

export const TableHeader = ({
  labels,
  sx,
  labelProps,
  children,
  ...rest
}: DashboardThProps) => {
  return (
    <Th
      verticalAlign={'top'}
      {...rest}
      sx={{
        py: 4,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: 'neutral.100',
        ...sx,
      }}
    >
      <Grid sx={{ gap: 1 }}>
        {children && children}

        {labels &&
          labels.map((label, i) => (
            <Text
              key={i}
              {...labelProps}
              sx={{
                color: '#728492',
                fontSize: 'sm',
                fontWeight: 'normal',
                ...labelProps?.sx,
              }}
            >
              {label}
            </Text>
          ))}
      </Grid>
    </Th>
  )
}
